const supportedUnits = ['B', 'KB', 'MB', 'GB', 'TB'];

export const isFileExtensionAcceptable = (filename: string, acceptableExtensions: string[]): boolean => {
  const pathParts = filename.split('.');
  let extension = '';
  if (pathParts.length < 2) {
    return false;
  } else {
    extension = pathParts[pathParts.length - 1];
  }

  return acceptableExtensions
    .map(normalizeFileExtension)
    .some((acceptableExtension) => acceptableExtension.toLowerCase() === extension.toLowerCase());
};

export const convertFilesize = (input: number, currentUnit: string, targetUnit?: string, appendUnit = true): string => {
  let currentUnitIndex = getCurrentUnitIndex(currentUnit);
  if (currentUnitIndex === -1) {
    return input + '';
  }

  const targetUnitIndex = getTargetUnitIndex(targetUnit);
  if (targetUnitIndex === -1) {
    while (currentUnitIndex === 0 || (input >= 1024 && currentUnitIndex < supportedUnits.length - 1)) {
      input /= 1024;
      currentUnitIndex++;
    }
  } else if (targetUnitIndex < currentUnitIndex) {
    while (currentUnitIndex > targetUnitIndex) {
      input *= 1024;
      currentUnitIndex--;
    }
  } else {
    while (currentUnitIndex < targetUnitIndex) {
      input /= 1024;
      currentUnitIndex++;
    }
  }

  return Math.round(input) + (appendUnit ? ' ' + supportedUnits[currentUnitIndex] : '');
};

const normalizeFileExtension = (extension: string) => {
  if (extension.startsWith('*.')) {
    return extension.substring(2);
  }
  if (extension.startsWith('.')) {
    return extension.substring(1);
  }
  return extension;
};

const getCurrentUnitIndex = (currentUnit: string) => supportedUnits.indexOf(currentUnit.toUpperCase());

const getTargetUnitIndex = (targetUnit?: string) => {
  if (!targetUnit) {
    return -1;
  }
  return supportedUnits.indexOf(targetUnit.toUpperCase());
};

export function convertFileToBase64(file: File): Promise<string> {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result as string);
    };
  });
}
